import { useFlags } from 'launchdarkly-react-client-sdk';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { StepButtonsConfig } from 'components/ButtonsBar/ButtonsBar';
import { CommonSteps } from 'modules/events/basics/enums/commonForms.enums';
import {
  CreateOnlineMeetingStepsIndex,
  CreateOnlineMeetingWithEmailConfigurationStepsIndex,
} from 'modules/events/routes/CreateOnlineMeeting/CreateOnlineMeeting.types';
import { ButtonType } from 'yoda-ui/components/Button/Button.types';
import { Icons } from 'yoda-ui/components/Icons/Icon';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useCreateOnlineMeetingButtons = (onlineMeetingActions: any, isPublished = false) => {
  const { handleSaveData,
    stepIndexer,
    handlePublishEvent,
    saveAndNext,
    saveAndPrevious } = onlineMeetingActions;
  const { t } = useTranslation();
  const flags = useFlags();

  const button = useMemo(() => {
    const firstStepButtons: StepButtonsConfig = {
      secondButton: {
        buttonProps: {
          onClick: handleSaveData,
          buttonType: ButtonType.neutral,
        },
        label: isPublished ? t('save_published_event') : t('toast_draft_saved'),
        hidden: false,
      },
      thirdButton: {
        buttonProps: {
          onClick: saveAndNext,
          buttonType: ButtonType.primary,
        },
        label: t('actions_next_label'),
        hidden: false,
      },
    };

    const SecondStepsButtons: StepButtonsConfig = {
      firstButton: {
        buttonProps: {
          onClick: saveAndPrevious,
          buttonType: ButtonType.secondary,
          startIconName: Icons.chevronLeft,
        },
        label: t('actions_previous_label'),
        hidden: false,
      },
      secondButton: {
        buttonProps: {
          onClick: handleSaveData,
          buttonType: ButtonType.neutral,
        },
        label: isPublished ? t('save_published_event') : t('toast_draft_saved'),
        hidden: false,
      },
      thirdButton: {
        buttonProps: {
          onClick: saveAndNext,
          buttonType: ButtonType.primary,
        },
        label: t('actions_next_label'),
        hidden: false,
      },
    };

    const ThirdStepsButtons: StepButtonsConfig = {
      firstButton: {
        buttonProps: {
          onClick: saveAndPrevious,
          buttonType: ButtonType.secondary,
          startIconName: Icons.chevronLeft,
        },
        label: t('actions_previous_label'),
        hidden: false,
      },
      secondButton: {
        buttonProps: {
          onClick: handleSaveData,
          buttonType: ButtonType.neutral,
        },
        label: isPublished ? t('save_published_event') : t('toast_draft_saved'),
        hidden: false,
      },
      thirdButton: {
        buttonProps: {
          onClick: saveAndNext,
          buttonType: ButtonType.primary,
        },
        label: t('actions_next_label'),
        hidden: false,
      },
    };

    const lastStepButtons: StepButtonsConfig = {
      firstButton: {
        buttonProps: {
          onClick: saveAndPrevious,
          buttonType: ButtonType.secondary,
          startIconName: Icons.chevronLeft,
        },
        label: t('actions_previous_label'),
        hidden: false,
      },
      secondButton: {
        buttonProps: {
          onClick: handleSaveData,
          buttonType: ButtonType.neutral,
        },
        label: isPublished ? t('save_published_event') : t('toast_draft_saved'),
        hidden: false,
      },
      thirdButton: {
        buttonProps: {
          onClick: handlePublishEvent,
          buttonType: ButtonType.primary,
        },
        label: t('actions_publish_label'),
        hidden: false,
      },
    };

    // TODO: Remove this block when epic BIOGENLINC-3524 is finished
    if (!flags.eventsBiogenlinc4151SectionEmail) {
      switch (CreateOnlineMeetingStepsIndex[stepIndexer.stepIndex]) {
        case CommonSteps.detailsStep:
          return firstStepButtons;
        case CommonSteps.publicationStep:
          return lastStepButtons;
        case CommonSteps.communicationStep:
          return SecondStepsButtons;
        default:
          return null;
      }
    }

    switch (CreateOnlineMeetingWithEmailConfigurationStepsIndex[stepIndexer.stepIndex]) {
      case CommonSteps.detailsStep:
        return firstStepButtons;
      case CommonSteps.publicationStep:
        return lastStepButtons;
      case CommonSteps.communicationStep:
        return SecondStepsButtons;
      case CommonSteps.emailConfigurationStep:
        return ThirdStepsButtons;
      default:
        return null;
    }
  }, [
    handleSaveData,
    isPublished,
    t,
    saveAndNext,
    saveAndPrevious,
    handlePublishEvent,
    flags.eventsBiogenlinc4151SectionEmail,
    stepIndexer.stepIndex,
  ]);

  return button;
};

export default useCreateOnlineMeetingButtons;
